import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function CompCollPolicies(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const decimal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const headers = [[ "Coverage Type", "Policies", "%", "Avg Prem", "Avg Vehicles" ]];

    const [data, setData] = React.useState([
        ["LIABILITY ONLY", integer.format(0), percent.format(0), currency.format(0), decimal.format(0)],
        ["COLL/COMP", integer.format(0), percent.format(0), currency.format(0), decimal.format(0)],
        ["COMP ONLY", integer.format(0), percent.format(0), currency.format(0), decimal.format(0)],
        ["TOTAL", integer.format(0), percent.format(0), currency.format(0), decimal.format(0)]
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Home/GetPoliciesByCoverageType", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = [
                [
                    "LIABILITY ONLY",
                    integer.format(response.liabilityOnlyPolicies),
                    percent.format(response.liabilityOnlyPercentage / 100),
                    currency.format(response.liabilityOnlyAvgPremium),
                    decimal.format(response.liabilityOnlyAvgVehicles)
                ], [
                    "COLL/COMP",
                    integer.format(response.collCompPolicies),
                    percent.format(response.collCompPercentage / 100),
                    currency.format(response.collCompAvgPremium),
                    decimal.format(response.collCompAvgVehicles)
                ], [
                    "COMP ONLY",
                    integer.format(response.compOnlyPolicies),
                    percent.format(response.compOnlyPercentage / 100),
                    currency.format(response.compOnlyAvgPremium),
                    decimal.format(response.compOnlyAvgVehicles)
                ], [
                    "TOTAL",
                    integer.format(response.totalPolicies),
                    percent.format(response.totalPercentage / 100),
                    currency.format(response.totalAvgPremium),
                    decimal.format(response.totalAvgVehicles)
                ]
            ];

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title="POLICIES BY COVERAGE TYPE"
                loading={loading}
                fixedColumns={1}
                headers={headers}
                rows={data.filter(x => x[0] !== 'TOTAL')}
                footers={data.filter(x => x[0] === 'TOTAL')}
                exportName="PoliciesByCoverageType"
            />
        </div>
    );
}
